import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { ProfileModule } from '../profile/profile.module';
import { VillageModule } from '../village/village.module';
import { IdeaActivityEntity } from './idea-activity.entity';
import { IdeaController } from './idea.controller';
import { IdeaEntity } from './idea.entity';
import { IdeaService } from './idea.service';
import { IdeaFilesEntity } from './ideafiles.entity';
@Module({
  imports: [
    TypeOrmModule.forFeature([IdeaEntity,IdeaFilesEntity,NotificationsEntity,IdeaActivityEntity]),
    ProfileModule,VillageModule
],
  controllers: [IdeaController],
  providers: [IdeaService],
  exports:[IdeaService],
})
export class IdeaModule {}
